<template>
  <v-container fluid>
    <v-row wrap>
      <v-col sm="12">
        <router-view/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default { }
  export { default as VehicleTypesList } from './List'
  export { default as VehicleTypesCreate } from './Create'
  export { default as VehicleTypesEdit } from './Edit'
</script>
